<div class="m-2" ngbAccordion>
  <div [collapsed]="true" ngbAccordionItem>
    <h2 class="bg-light" ngbAccordionHeader>
      <button class="bg-light" ngbAccordionButton>
        <div class="d-flex w-100 justify-content-between align-items-center">
          <div>
            <i class="bi bi-building fs-4 me-2"></i>
            <span class="h5">{{ item.name }}</span>
            <small class="text-muted">
              <i class="bi bi-geo-alt ms-2"></i>
              {{ item.addressArray.streetName }} {{ item.addressArray.houseNumber }},
              {{ item.addressArray.postalCode }} {{ item.addressArray.cityName }}
            </small>
            <small *ngIf="item.constructionYear" class="text-muted">
              <i class="bi bi-calendar3 me-1"></i>
              {{ item.constructionYear|date:'yyyy' }}
            </small>
            <span [type]="item.currentState" propertyStatusBadge></span>
          </div>
          <div>
                  <span class="badge me-2 bg-info">
                    <i class="bi bi-door-open me-1"></i>
                    {{ data()?.data?.data?.length }} {{ 'MENU.APARTMENTS' | translate }}
                  </span>
            <span class="badge me-2 bg-warning">
                    {{ item.occupancyPercentage }}%
                  </span>
          </div>
        </div>
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <ul class="list-group" style="max-height: 300px; overflow-y: auto">
            @for (APT of (data()?.data?.data || []); track APT.id) {
              <li class="list-group-item">
                <div class="row gy-3 align-items-center">
                  <!-- Apartment Info -->
                  <div class="col-12 col-md-4">
                    <i class="bi bi-house-door-fill me-2"></i>
                    <strong>
                      {{ 'METER.APARTMENT' | translate }}
                      <span apartmentUnitStatusBadge class="badge ms-2" [type]="APT.unitStatus"></span>
                    </strong>
                    <br/>
                    <i class="las la-layer-group"></i>
                    {{ 'APARTMENT.FLOOR' | translate }} {{ APT.floor }} – {{ APT.size }} m<sup>2</sup>
                  </div>

                  <!-- Action Buttons -->
                  <div class="col-12 col-md-4">
                    <div class="d-flex justify-content-center flex-wrap gap-2">
                      <a
                        [routerLink]="[Resources.UniversalBillingApartmentsProfile | resourceById:APT.id]"
                        fragment="invoices"
                        class="btn btn-sm btn-primary"
                      >
                        <i class="las la-file-invoice"></i> {{ 'MENU.INVOICES' | translate }}
                      </a>
                      <a
                        [routerLink]="[Resources.UniversalBillingApartmentsProfile | resourceById:APT.id]"
                        class="btn btn-sm btn-info"
                        fragment="readings"
                      >
                        <i class="las la-bolt"></i> {{ 'MENU.READINGS' | translate }}
                      </a>
                      <a
                        [routerLink]="[Resources.UniversalBillingApartmentsProfile | resourceById:APT.id]"
                        class="btn btn-sm btn-success"
                        fragment="payments"
                      >
                        <i class="las la-money-check-alt"></i> {{ 'MENU.PAYMENTS' | translate }}
                      </a>
                    </div>
                  </div>

                  <div class="col-12 col-md-4 text-md-end text-center">
                    <button type="button" class="btn btn-sm btn-info">
                      <i class="bi bi-people-fill me-1"></i> {{ APT.numberOfRenters }}
                    </button>
                  </div>
                </div>
              </li>
            } @empty {
              <li class="list-group-item text-center"><i
                class="las la-search-minus"></i> {{ 'PROPERTY.NO_APARTMENTS_AVAILABLE' | translate }}
              </li>
            }
          </ul>
        </ng-template>
      </div>
    </div>
  </div>
</div>
